// test251
(251 && 0);
